var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Container, Row, Col } from 'reactstrap';
import Box from "./Box";
var BannerView = /** @class */ (function (_super) {
    __extends(BannerView, _super);
    function BannerView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BannerView.prototype.render = function () {
        return (React.createElement(Box, { style: this.props.style, className: 'banner-view', noPadding: true },
            React.createElement(Container, { onClick: this.props.onClick },
                React.createElement(Row, { className: 'row-container' },
                    React.createElement(Col, { className: "my-auto" },
                        React.createElement("div", { className: 'img-container' },
                            React.createElement("img", { className: 'banner-img', src: this.props.image, alt: "logo" }))),
                    React.createElement(Col, { className: "vertical-line-col" },
                        React.createElement("div", { className: "vertical-line" })),
                    React.createElement(Col, { xs: "3", className: "title-col my-auto" },
                        React.createElement("div", { className: 'banner-title' }, this.props.title))))));
    };
    return BannerView;
}(React.PureComponent));
export default BannerView;
//# sourceMappingURL=BannerView.js.map


//////////////////
// WEBPACK FOOTER
// ./bpm-web-generic/lib/components/BannerView.js
// module id = 976
// module chunks = 0